import { Injectable } from '@angular/core';
import { WancomHttpService } from '../wancom-http/wancom-http.service';
import { environment } from '../../../environments/environment';
import { PaymentIntentResult } from '@stripe/stripe-js';

@Injectable({
    providedIn: 'root',
})
export class StripePaymentService {
    url = 'Payment';
    constructor(private http: WancomHttpService) {}

    public newPayment(orderId: number) {
        return this.http.post<StripePaymentInfo>(
            `${this.url}/NewPayment/${orderId}`,
            {},
            environment.apiBaseStore
        );
    }

    public confirmPayment(paymentIntentId: string) {
        return this.http.post<PaymentIntentResult>(
            `${this.url}/ConfirmPayment/${paymentIntentId}`,
            {},
            environment.apiBaseStore
        );
    }

    /**
     * @deprecated
    * @param body 
     * @returns 
     */
    public createEphemeralKey(body: { issuing_card: string; nonce: any }) {
        return this.http.post(
            `${this.url}/ephemeral-keys`,
            body,
            environment.apiBaseStore
        );
    }
}

export interface StripePaymentInfo {
    /**
     * Identifiant unique de l'utilisateur
     */
    clientSecret: string;
    /**
     * Id de l'intention de paiement
     */
    paymentIntentId: string;
    /**
     * Description du paiement
     */
    description: string;
    /**
     * Prix du paiement en centimes
     */
    amount: number;
}
